<template>
  <IconLucideFolderCheck />
</template>
